import { PaginationBody } from '@Entities/pagination'
import { base, paginationPath, publicBase2v, rightsholderBase2v } from '@App/dicts/pathes'

export class Work {
    worksDraftsRH = (rightsholderId: number, pagination?: PaginationBody) =>
        base(`rightsholder/${rightsholderId}/works/drafts${pagination ? paginationPath(pagination) : ''}`)
    workDraftRH = (draftId: number) => base(`drafts/${draftId}`)
    postWork = (rightsholderId: number, originalSubmissionId?: number) =>
        rightsholderBase2v(
            rightsholderId,
            originalSubmissionId !== undefined ? `work?originalSubmissionId=${originalSubmissionId}` : 'work'
        )
    workById = (workId: number, rightsHolderId: number) => rightsholderBase2v(rightsHolderId, `work/${workId}/summary`)
    submissionById = (workId: number, rightsholderId: number) =>
        rightsholderBase2v(rightsholderId, `transaction/${workId}`)
    summaryById = (workId: number, rightsHolderId: number) =>
        rightsholderBase2v(rightsHolderId, `catalog/${workId}/summary`)
    catalogWorkById = (workId: string) => publicBase2v(`work/${workId}`)
    createWriter = base('writer')
    dismissWork = (rightsholderId: number, workId: number) =>
        rightsholderBase2v(rightsholderId, `work/${workId}/dismiss`)
}
